import React, { useEffect, createContext, useContext, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import iphone from "../assets/iphone.mp3";

const SocketContext = createContext();

export function SocketData() {
  return useContext(SocketContext);
}

const SocketContextProvider = ({ children }) => {
  const socket = useRef(null);
  const [openChat, setOpenChat] = useState(false);
  const [messageToArrive, setMessageToArrive] = useState(null);
  const [readStatus, setReadStatus] = useState(null);
  const [online, setOnline] = useState([]);
  const [notifToArrive, setNotifToArrive] = useState({
    text: "Note: This notification will self destruct upon page reload or leaving site. Data are not saved.",
  });
  const user = useSelector((state) => state.cartDetail);
  const admin = useSelector((state) => state.adminDetail);
  const dispatch = useDispatch();
  function playSound(url) {
    const audio = new Audio(url);
    audio.play();
  }
  useEffect(() => {
    socket.current = io(
      process.env.PRODUCTION
        ? "https://amy-socket.onrender.com"
        : "http://localhost:8083"
    );
    socket.current.emit("sendUser", admin?.userId);
    socket.current.on("getChatMessage", (data) => {
      setMessageToArrive({
        sender: data.senderId,
        text: data.text,
        createdAt: Date.now(),
      });
      playSound(iphone);
      // getSender(data.senderId);
    });
    socket.current.on("receivedRead", (data) => {
      setReadStatus({
        sender: data.senderId,
        receiver: data.receiverId,
      });
      // playSound(iphone);
      // getSender(data.senderId);
    });
    socket.current.on("setOnline", (online) => {
      setOnline(online);
    });
    socket.current.on("getMessage", (data) => {
      setOpenChat(true);

      setNotifToArrive({
        sender: data.senderId,
        text: data.text,
        createdAt: Date.now(),
      });
      playSound(iphone);
    });
    socket.current.on("getNotification", (data) => {
      setOpenChat(true);

      setNotifToArrive({
        text: data.text,
      });
      playSound(iphone);
    });
  }, [admin?.userId]);

  return (
    <SocketContext.Provider
      value={{
        openChat,
        socket,
        messageToArrive,
        notifToArrive,
        readStatus,
        setOpenChat,
        online,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export { SocketContextProvider };
